import React from 'react';
export function BigIdea() {
  return <section className="w-full bg-ink py-20 sm:py-28" data-id="element-20" data-mp="1vstwp7cd25n7">
      <div className="mx-auto max-w-4xl px-5 text-center" data-id="element-21" data-mp="2p9f06o6v1q54">
        <h2 className="font-serif text-2xl leading-snug sm:text-[2.9rem] sm:leading-[1.18] text-ivory" data-id="element-22" data-mp="2pc16kki0lzlr">
          La diferencia entre &ldquo;la que ayuda con las bodas&rdquo; y la wedding planner
          que cobra 3.000 dólares no es el talento. Tampoco son los contactos. Y muchísimo
          menos un diploma.
        </h2>
        <p className="mt-8 font-serif text-3xl italic leading-snug sm:text-5xl text-gold" data-id="element-23" data-mp="26j72illxjrwb">
          Es el sistema que corre por detrás del negocio.
        </p>
        <div className="rule-gold mx-auto mt-10 w-40" aria-hidden="true" data-id="element-24" data-mp="2bh8j8zvvvf4m" />
        <p className="mx-auto mt-10 max-w-2xl text-base sm:text-lg leading-relaxed text-ivory/70" data-id="element-25" data-mp="2ga1qbuetqzjv">
          Las agencias top no decoran mejor que tú. Operan distinto. Tienen guiones para el
          primer WhatsApp, protocolos para cuando el cliente desaparece, estructuras de
          precio que sostienen sin temblar y una máquina de recomendación que les llena la
          agenda. Eso no se enseña en ningún curso: vive en manuales internos que nadie
          publica.
        </p>
        <p className="mt-8 text-[11px] uppercase tracking-[0.24em] text-gold" data-id="element-26" data-mp="2kawggcejidzg">
          Un certificado dice que estudiaste. Un sistema hace que te paguen.
        </p>
      </div>
    </section>;
}